/* eslint-disable no-undef */
import axios from 'axios';
import * as types from '../constantes/user';

export const SignAction = (email, password) => async (dispatch) => {
  dispatch({
    type: types.USER_SIGNIN_REQUEST,
    payload: { email, password },
  });

  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/api/users/login`, {
      email,
      password,
    });
    dispatch({
      type: types.USER_SIGNIN_SUCESS,
      payload: data,
    });
    localStorage.setItem('userInfo', JSON.stringify(data));
    document.location.href = '/';
  } catch (error) {
    dispatch({
      type: types.USER_SIGNIN_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const SignOutAction = () => (dispatch) => {
  localStorage.removeItem('userInfo');
  dispatch({ type: types.USER_SIGNOUT });
  document.location.href = '/login';
};

export const CreateUserAction =
  (name, email, password, confirmPassword, company, accessMode, contract, cpf, cnpj, companyName) =>
  async (dispatch, getState) => {
    dispatch({
      type: types.CREATE_USER_REQUEST,
      payload: { name, email, password, confirmPassword, company, accessMode, contract, cpf, cnpj, companyName },
    });

    try {
      const {
        userSign: { userInfo },
      } = getState();

      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/users/add`,
        {
          name,
          email,
          password,
          confirmPassword,
          company,
          accessMode,
          contract,
          cpf,
          cnpj,
          companyName,
        },
        { headers: { Authorization: `bearer ${userInfo.token}` } },
      );
      dispatch({
        type: types.CREATE_USER_SUCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: types.CREATE_USER_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
    }
  };

export const GetUserProjectAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: types.GET_USER_PROJECT_REQUEST,
    payload: id,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/project/historic/${id}`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.GET_USER_PROJECT_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.GET_USER_PROJECT_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const SearchUsersAction = () => async (dispatch, getState) => {
  dispatch({
    type: types.SEARCH_USERS_REQUEST,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/users`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.SEARCH_USERS_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_USERS_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const UpdateUserAction = (email, oldPassword, newPassword) => async (dispatch, getState) => {
  dispatch({
    type: types.UPDATE_USER_REQUEST,
    payload: { email, oldPassword, newPassword },
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/users/profile`,
      {
        email,
        oldPassword,
        newPassword,
      },
      {
        headers: { Authorization: `bearer ${userInfo.token}` },
      },
    );
    dispatch({
      type: types.UPDATE_USER_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.UPDATE_USER_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const RecoverPasswordUserAction = (email) => async (dispatch) => {
  dispatch({
    type: types.RECOVER_PASSWORD_USER_REQUEST,
    payload: { email },
  });

  try {
    const { data } = await axios.put(`${process.env.REACT_APP_API_URL}/api/users/recover`, {
      email,
    });
    dispatch({
      type: types.RECOVER_PASSWORD_USER_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.RECOVER_PASSWORD_USER_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const SearchSpecifyUserAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: types.SEARCH_SPECIFY_USER_REQUEST,
    payload: id,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/${id}`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.SEARCH_SPECIFY_USER_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_SPECIFY_USER_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const UpdateAdminUserAction =
  (id, name, email, accessMode, isActive, confirmEmail, contract, cpf, cnpj, companyName, company) =>
  async (dispatch, getState) => {
    dispatch({
      type: types.UPDATE_ADMIN_USER_REQUEST,
      payload: { id, name, email, accessMode, isActive, confirmEmail, contract, cpf, cnpj, companyName, company },
    });

    try {
      const {
        userSign: { userInfo },
      } = getState();

      const { data } = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/users/update/${id}`,
        {
          name,
          email,
          accessMode,
          isActive,
          confirmEmail,
          contract,
          cpf,
          cnpj,
          companyName,
          company,
        },
        {
          headers: { Authorization: `bearer ${userInfo.token}` },
        },
      );
      dispatch({
        type: types.UPDATE_ADMIN_USER_SUCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: types.UPDATE_ADMIN_USER_ERROR,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
    }
  };

export const SearchCompanyUserAction = (id) => async (dispatch, getState) => {
  dispatch({
    type: types.SEARCH_COMPANY_USERS_REQUEST,
    payload: id,
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/api/users/list/${id}`, {
      headers: { Authorization: `bearer ${userInfo.token}` },
    });
    dispatch({
      type: types.SEARCH_COMPANY_USERS_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.SEARCH_COMPANY_USERS_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const ResendEmailUserAction = (email) => async (dispatch, getState) => {
  dispatch({
    type: types.RESEND_EMAIL_USER_REQUEST,
    payload: { email },
  });

  try {
    const {
      userSign: { userInfo },
    } = getState();

    const { data } = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/users/resend/code`,
      {
        email,
      },
      {
        headers: { Authorization: `bearer ${userInfo.token}` },
      },
    );
    dispatch({
      type: types.RESEND_EMAIL_USER_SUCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: types.RESEND_EMAIL_USER_ERROR,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};
